import { useCallback } from 'react';
import AblyChannelProvider from 'personalization-lib/components/wrappers/AblyChannelProvider';
import usePersonalizationStrategy from 'personalization-lib/hooks/variants/usePersonalizationStrategy';
import { getVariantGenerationChannelName } from 'personalization-lib/utils/ably/channels';
import { getName } from 'personalization-lib/utils/executionInputs';
import { parseMessage } from 'personalization-lib/utils/ably/messages';
import { EXECUTION_STATUS } from 'personalization-lib/constants/suggestions';
import { jsx as _jsx } from "react/jsx-runtime";
const VariantGenerationChannelSubscriber = ({
  strategyId,
  onMessageProcessed = () => {},
  onGenerationSuccess = () => {},
  onGenerationError = () => {},
  onMessageError = () => {}
}) => {
  const channelName = getVariantGenerationChannelName(strategyId);
  const {
    strategy
  } = usePersonalizationStrategy(strategyId);
  const handleMessage = useCallback(message => {
    try {
      const data = parseMessage(message);
      const requests = strategy === null || strategy === void 0 ? void 0 : strategy.aiExecutionRequests;
      const request = requests === null || requests === void 0 ? void 0 : requests.find(exec => exec.id === data.requestId);
      const assetName = (request === null || request === void 0 ? void 0 : request.inputs) && getName(request.inputs);
      const userId = request === null || request === void 0 ? void 0 : request.userId;
      if (!assetName) {
        throw new Error(`Name not found: ${JSON.stringify(request === null || request === void 0 ? void 0 : request.inputs)}`);
      }
      if (data.status === EXECUTION_STATUS.COMPLETED) {
        const assetCoordinates = data.assetCoordinates;
        onGenerationSuccess({
          assetName,
          assetCoordinates,
          userId
        });
      } else if (data.status === EXECUTION_STATUS.FAILED) {
        onGenerationError({
          assetName,
          userId
        });
      } else {
        throw new Error('Unknown AI execution status');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : String(err);
      onMessageError(new Error(`[PersonalizationAbly]${errorMessage}\n${message.data}`));
    }
    onMessageProcessed();
  }, [onGenerationSuccess, onGenerationError, onMessageError, onMessageProcessed, strategy === null || strategy === void 0 ? void 0 : strategy.aiExecutionRequests]);
  return /*#__PURE__*/_jsx(AblyChannelProvider, {
    channelName: channelName,
    onMessage: handleMessage
  });
};
export default VariantGenerationChannelSubscriber;